
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';

/**
 * truncate : Global filter for truncate strings
 */
Vue.filter('truncate', function(value, length, omission) {
    var length = length ? parseInt(length, 10) : 20;
    var ommision = omission ? omission.toString() : '…';
    if (value.length <= length) {
        return value;
    }
    return value.substring(0, length) + ommision;
});

/**
 * Component : vue-spinner
 * @see https://www.npmjs.com/package/vue-spinner
 */
Vue.component('pulse-loader', require('vue-spinner/src/PulseLoader.vue').default);
Vue.component('clip-loader', require('vue-spinner/src/ClipLoader.vue').default);
/**
 * Component : FeedNews
 */
Vue.component('feed-component', require('./components/Feed.vue').default);
Vue.component('feed-basic-component', require('./components/FeedBasic.vue').default);
/**
 * Component : FeedVoice
 */
Vue.component('feed-voice-component', require('./components/FeedBasicVoice.vue').default);
/**
 * Component : FeedPickup
 */
Vue.component('feed-pickup-component', require('./components/FeedPickup.vue').default);

/**
 * Component : NewsPickup
 */
Vue.component('news-pickup-component', require('./components/NewsPickup.vue').default);
/**
 * Component : BankAndBankBranchSuggest
 */
Vue.component('bank-and-bank-branch-suggest-component', require('./components/BankAndBankBranchSuggest.vue').default);

const app = new Vue({
    el: '#vue_app',
});